import { useQuery } from '@tanstack/react-query';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { selectUserCountry } from 'store/auth/selectors';
import { AIRTABLE_CONFIG } from '../config';
import { AirtableBase, CountryConfig } from '../types';

const getConfig = async (country: string) => {
  // TODO: Get this via backend API.
  return AIRTABLE_CONFIG?.[country as keyof typeof AIRTABLE_CONFIG];
};

const useAirtableConfig = (country?: string) => {
  const userCountry = useSelector(selectUserCountry);

  const query = useQuery({
    queryKey: [
      'airtable-config',
      {
        country: country || userCountry,
      },
    ],
    queryFn: () => getConfig(country || userCountry),
    staleTime: Infinity,
  });

  const config = query?.data;

  const getSelectedTableConfig = useCallback(
    (baseId: string, tableId: string) => {
      const countryConfig = config;
      const baseConfig = countryConfig?.bases?.[
        baseId as keyof typeof countryConfig.bases
      ] as unknown as AirtableBase;

      const tableConfig =
        baseConfig?.tables?.[tableId as keyof typeof baseConfig.tables];

      return tableConfig;
    },
    [config],
  );

  const getSelectedTableConfigProperty = useCallback(
    (baseId: string, tableId: string, key: string) => {
      const tableConfig = getSelectedTableConfig(baseId, tableId);
      return tableConfig?.[key as keyof typeof tableConfig];
    },
    [],
  );

  const getUserCountryConfig = useCallback(() => {
    return config || ({} as CountryConfig);
  }, [country, userCountry, config]);

  return {
    ...query,
    getSelectedTableConfig,
    getSelectedTableConfigProperty,
    getUserCountryConfig,
  };
};

export default useAirtableConfig;
